var _rect, _rect2, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _path9, _mask, _rect4, _mask2, _rect5, _circle2, _circle3, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _rect16, _path41, _path42, _path43, _rect17, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _ellipse, _circle5, _path58, _path59, _path60, _path61, _path62, _path63, _circle6, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 601,
    viewBox: "0 0 740 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 122.261,
    height: 93.7008,
    transform: "matrix(-1 0 0 1 680.507 38.895)",
    fill: "#FDF2D6",
    stroke: "#189BDC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 132.596,
    height: 101.592,
    transform: "matrix(-1 0 0 1 685.58 34.9492)",
    stroke: "#189BDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M643.075 102.33L680.638 132.93H559.112L605.513 89.5808L633.132 115.93L643.075 102.33Z",
    fill: "#CDEBF7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 13.5287,
    transform: "matrix(-1 0 0 1 652.194 74.2201)",
    fill: "#CDEBF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.729 290.896H123.512L64.1015 599.613H60.1406L108.729 290.896Z",
    fill: "#312E63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.512 290.896H112.33L78.3989 525.32L123.512 290.896Z",
    fill: "#232056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M468.62 291.19H453.837L513.247 599.908H517.208L468.62 291.19Z",
    fill: "#312E63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M453.836 291.19H461.228L502.092 541.944L453.836 291.19Z",
    fill: "#232056"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M525.788 291.242C525.788 287.836 523.027 285.075 519.621 285.075H54.1456C50.7396 285.075 47.9785 287.836 47.9785 291.242C47.9785 294.648 50.7396 297.409 54.1456 297.409H519.621C523.027 297.409 525.788 294.648 525.788 291.242Z",
    fill: "#312E63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M242.641 251.826H190.846L178.289 285.074H230.084L242.641 251.826Z",
    fill: "#027AC3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.846 251.826H242.641L240.008 258.798H188.213L190.846 251.826Z",
    fill: "#1C43AD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 92.2371,
    height: 5.89888,
    transform: "matrix(-1 0 0 1 257.656 279.176)",
    fill: "#1C43AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M311.181 253.972H122.083C118.769 253.972 116.083 251.286 116.083 247.972V244.957C116.083 241.643 118.769 238.957 122.083 238.957H311.181C314.495 238.957 317.181 241.643 317.181 244.957V247.972C317.181 251.286 314.495 253.972 311.181 253.972Z",
    fill: "#027AC3"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-1_1013_19579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201.098,
    height: 140.501,
    rx: 6,
    transform: "matrix(-1 0 0 1 317.181 113.471)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 201.098,
    height: 140.501,
    rx: 6,
    transform: "matrix(-1 0 0 1 317.181 113.471)",
    stroke: "#027AC3",
    strokeWidth: 18,
    mask: "url(#path-14-inside-1_1013_19579)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-2_1013_19579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.239,
    height: 29.4944,
    rx: 3,
    transform: "matrix(-1 0 0 1 293.049 201.955)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 129.239,
    height: 29.4944,
    rx: 3,
    transform: "matrix(-1 0 0 1 293.049 201.955)",
    stroke: "#CDEBF7",
    strokeWidth: 8,
    mask: "url(#path-15-inside-2_1013_19579)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 9.65272,
    transform: "matrix(-1 0 0 1 283.396 135.994)",
    fill: "#CDEBF7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 9.65272,
    transform: "matrix(-1 0 0 1 277.498 218.579)",
    fill: "#CDEBF7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 121.195,
    height: 16.0879,
    rx: 8.04393,
    transform: "matrix(-1 0 0 1 261.946 127.951)",
    fill: "#CDEBF7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 50.4086,
    height: 7.50767,
    rx: 3.75383,
    transform: "matrix(-1 0 0 1 213.146 160.126)",
    fill: "#CDEBF7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 77.758,
    height: 3.75383,
    rx: 1.87692,
    transform: "matrix(-1 0 0 1 253.366 208.926)",
    fill: "#CDEBF7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 77.758,
    height: 3.75383,
    rx: 1.87692,
    transform: "matrix(-1 0 0 1 253.366 216.97)",
    fill: "#CDEBF7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 77.758,
    height: 3.75383,
    rx: 1.87692,
    transform: "matrix(-1 0 0 1 253.366 224.478)",
    fill: "#CDEBF7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 50.4086,
    height: 7.50767,
    rx: 3.75383,
    transform: "matrix(-1 0 0 1 293.049 172.997)",
    fill: "#CDEBF7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 50.4086,
    height: 7.50767,
    rx: 3.75383,
    transform: "matrix(-1 0 0 1 293.049 160.126)",
    fill: "#CDEBF7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 50.4086,
    height: 7.50767,
    rx: 3.75383,
    transform: "matrix(-1 0 0 1 213.146 172.997)",
    fill: "#CDEBF7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 50.4086,
    height: 7.50767,
    rx: 3.75383,
    transform: "matrix(-1 0 0 1 293.049 185.867)",
    fill: "#CDEBF7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 50.4086,
    height: 7.50767,
    rx: 3.75383,
    transform: "matrix(-1 0 0 1 213.146 185.867)",
    fill: "#CDEBF7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 3.21757,
    transform: "matrix(-1 0 0 1 216.9 246.464)",
    fill: "#1C43AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.962 420.508V407.412V347.799C335.962 315.058 397.032 315.058 462.378 315.058C465.481 287.306 468.823 224.037 484.718 219.472C548.115 201.266 562.102 223.025 556.298 270.834C537.681 424.25 517.478 420.508 499.792 420.508H335.962Z",
    fill: "#027AC3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M391.553 268.125C399.786 270.018 410.112 266.897 414.246 267.246L411.288 284.4C407.946 284.535 400.577 284.647 397.832 284.016C394.402 283.227 388.398 281.847 386.289 283.168C384.179 284.489 373.222 285.611 368.932 284.807C370.541 276.227 381.262 265.759 391.553 268.125Z",
    fill: "#FDCBB4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M391.553 268.125C399.786 270.018 410.112 266.897 414.246 267.246L411.288 284.4C410.623 284.427 409.799 284.453 408.884 284.472L411.288 268.451C408.05 269.096 399.568 270.16 391.553 269.255C381.534 268.125 373.49 273.814 368.932 284.807C370.541 276.227 381.262 265.759 391.553 268.125Z",
    fill: "#F1A089"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M286.161 568.477C303.326 563.666 295.577 536.155 295.577 536.155L338.568 527.558C338.568 527.558 334.782 545.576 337.406 561.723C338.869 570.726 340.022 588.006 338.132 594.012C333.588 604.985 269.067 596.55 286.161 568.477Z",
    fill: "#FDCBB4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M338.568 527.557C338.568 527.557 334.783 545.576 337.407 561.722C338.87 570.725 340.023 588.006 338.132 594.011C337.774 594.876 337.044 595.62 336.01 596.244C337.893 588.843 338.529 571.108 336.036 566.644C333.543 562.18 335.469 554.596 333.268 555.622C327.916 558.116 309.983 554.638 296.787 555.336C296.6 548.85 295.577 536.155 295.577 536.155L338.568 527.557Z",
    fill: "#F1A089"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M236.496 586.194C246.002 584.364 270.149 572.774 286.756 568.268C293.837 573.705 293.204 583.731 295.493 588.328C297.782 592.925 298.821 596.066 318.622 596.083C338.423 596.101 336.549 594.428 338.217 594.012C339.885 593.596 340.088 599.862 338.837 599.861C338.273 599.861 319.972 600.651 300.35 598.352C274.387 600.23 247.634 599.895 242.945 599.776C234.399 599.56 228.99 588.067 236.496 586.194Z",
    fill: "#1C43AD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M326.307 170.8C327.961 176.922 333.12 180.82 335.493 182.004C333.712 183.853 329.208 188.628 325.444 192.93C323.721 186.552 311.107 189.9 304.331 178.106C294.122 160.336 305.275 158.807 310.745 161.321C315.433 163.476 321.835 175.43 320.982 168.817C319.104 154.27 324.239 163.147 326.307 170.8Z",
    fill: "#FDCBB4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M325.444 192.93C323.721 186.552 311.108 189.9 304.332 178.106C298.858 168.577 299.526 163.718 302.166 161.648C299.216 169.721 302.261 170.865 304.847 177.765C306.454 182.056 316.376 188.49 323.617 188.49L330.492 178.106C332.326 180.075 334.277 181.396 335.494 182.003C333.712 183.853 329.209 188.628 325.444 192.93Z",
    fill: "#F1A089"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M178.223 490.451C195.162 495.686 205.732 458.669 205.732 458.669L246.519 485.376C246.519 485.376 234.29 498.634 225.461 512.857C220.648 520.61 214.007 536.397 209.094 540.336C198.391 548.083 153.986 506.292 178.223 490.451Z",
    fill: "#FDCBB4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M246.516 485.375C246.516 485.375 234.287 498.633 225.459 512.856C220.646 520.609 214.005 536.397 209.092 540.335C208.152 540.178 207.194 539.975 206.223 539.727C218.352 531.866 218.238 516.834 222.344 512.097C225.417 508.553 237.247 495.894 230.239 494.753C223.232 493.613 215.26 479.135 200.17 472.824C201.94 468.82 205.33 460.502 205.33 460.502L246.516 485.375Z",
    fill: "#F1A089"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.501 478.495C137.408 482.278 160.306 484.702 180.06 490.83C182.914 499.278 176.816 507.227 176.16 512.309C175.503 517.391 175.275 520.195 191.7 531.245C208.125 542.294 207.499 539.865 209.115 540.449C210.73 541.034 207.415 546.336 206.378 545.638C205.34 544.94 133.275 498.277 126.303 493.336C119.33 488.394 121.23 475.864 128.501 478.495Z",
    fill: "#1C43AD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M398.997 215.682C441.339 177.018 443.205 162.271 461.17 162.002C459.602 176.967 454.513 213.766 441.339 242.315C428.402 254.978 398.997 269.944 382.531 258.432C369.358 249.223 334.308 212.385 322.546 195.117L334.308 176.699C355.479 190.129 396.174 219.365 398.997 215.682Z",
    fill: "#F6BC33"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M334.308 176.699L322.546 195.117",
    stroke: "white",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M441.339 242.315C436.782 246.775 430.183 251.52 422.827 255.294C429.709 234.028 444.652 189.781 449.372 182.917C454.091 176.052 458.546 171.655 460.184 170.314C457.851 188.055 452.493 218.142 441.339 242.315Z",
    fill: "#DD9D13"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M471.627 160.394C447.763 184.525 483.693 197.932 503.267 156.683L500.894 139.649C495.631 139.145 480.243 138.139 471.525 138.139C477.58 150.888 474.049 158.076 471.627 160.394Z",
    fill: "#FDCBB4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M500.893 139.649C495.63 139.145 480.243 138.139 471.525 138.139C476.172 147.925 475.171 154.435 473.36 157.98C483.756 157.337 496.047 145.491 500.893 139.649Z",
    fill: "#F1A089"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M473.279 146.286C497.1 154.588 509.708 129.065 515.868 118.029C530.468 83.0743 461.707 84.6609 461.707 91.7515C461.707 99.5266 456.345 140.385 473.279 146.286Z",
    fill: "#FDCBB4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M515.868 118.029C530.468 83.0743 461.707 84.6609 461.707 91.7515C461.707 94.3828 461.093 100.803 460.936 108.376C477.595 115.079 493.078 105.158 493.346 111.325C493.614 117.492 499.245 127.145 500.317 125.268C503.267 120.71 502.194 108.912 508.629 115.347C515.064 121.782 500.317 131.703 500.049 133.312C499.835 134.599 499.602 138.86 499.513 140.829C507.312 134.039 512.559 123.957 515.868 118.029Z",
    fill: "#F1A089"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M535.442 192.301C533.59 167.219 514.259 161.734 503.266 156.639C468.14 197.395 456.878 176.213 471.627 160.393C469.698 160.393 465.311 160.856 457.906 162.714C442.668 195.227 423.094 261.747 415.05 311.083C437.42 314.566 500.487 322.613 531.961 322.613C533.118 308.678 537.756 223.653 535.442 192.301Z",
    fill: "#F6BC33"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M503.267 156.639C468.14 197.395 456.879 176.213 471.627 160.393",
    stroke: "white",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M535.442 192.301C534.643 181.482 530.593 174.309 525.362 169.241C516.567 164.862 497.956 163.932 493.881 195.25C488.786 234.397 489.323 240.028 488.786 243.782C488.357 246.785 447.365 253.077 426.922 255.848C423.949 267.51 421.248 279.2 418.968 290.437C494.391 303.307 526.903 297.408 533.731 292.85C535.326 261.096 537.038 213.928 535.442 192.301Z",
    fill: "#DD9D13"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M493.872 418.896C546.276 403.298 542.799 351.571 532.317 317.25C429.83 320.76 292.89 307.113 290.069 346.793C288.905 363.174 286.575 549.988 290.069 549.988C306.725 549.988 370.004 557.495 380.989 549.988C376.33 527.757 362.316 452.827 358.822 399.006C406.559 418.896 481.058 422.71 493.872 418.896Z",
    fill: "#12AAE4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M447.678 317.743C367.267 317.27 292.152 317.512 290.07 346.793C289.426 355.846 288.427 416.955 288.251 469.817C301.47 426.201 323.617 343.735 335.684 333.874C347.944 323.855 397.791 319.399 447.678 317.743C476.235 317.911 505.459 318.17 532.317 317.25C510.26 316.768 478.961 316.705 447.678 317.743Z",
    fill: "#0F8DC2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M358.822 399.005C360.978 399.904 363.188 400.769 365.445 401.603C355.793 390.45 345.496 374.308 343.995 366.586C345.496 376.239 356.564 398.047 359.497 408.146C359.242 405.043 359.015 401.992 358.822 399.005Z",
    fill: "#0F8DC2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M288.992 541.407C320.4 539.262 353.112 549.183 369.468 543.552C368.127 534.168 349.626 414.85 351.235 394.204C352.844 373.557 378.048 414.85 491.736 412.436C501.657 412.436 546.703 391.979 524.716 317.478",
    stroke: "white",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M297.455 298.218C318.92 301.964 470.42 312.755 540.805 332.265C540.805 332.265 342.752 296.61 324.691 341.917C306.63 387.225 276.522 496.809 267.189 518.348C249.614 512.717 222.801 481.763 197.061 463.649C259.267 339.117 270.623 293.536 297.455 298.218Z",
    fill: "#12AAE4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M200.93 455.873C220.12 468.207 248.274 501.992 263.021 506.282C278.611 469.63 297.74 391.073 318.525 350.23C321.346 344.685 324.285 340.406 327.253 337.091",
    stroke: "white",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M452.837 93.9846C454.925 74.184 470.493 74.5938 478.657 77.616C483.108 72.3076 494.587 68.6775 500.458 71.2335C514.335 77.2748 515.406 89.4535 515.38 94.6834C530.992 110.445 515.46 125.935 509.935 129.601C509.287 130.563 505.522 137.963 501.352 143.107C498.954 139.386 500.641 136.565 500.813 134.233C501.028 131.318 504.851 130.834 509.51 123.918C514.169 117.001 507.86 111.441 503.932 112.729C500.004 114.018 502.563 125.795 499.556 123.77C491.744 117.196 498.44 104.659 486.055 108.119C468.286 113.084 451.46 107.044 452.837 93.9846Z",
    fill: "#05185A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M486.048 108.121C468.278 113.086 451.452 107.046 452.83 93.9864C453.599 86.6867 456.201 82.1338 459.589 79.4459C450.652 100.187 473.505 107.205 486.048 108.121Z",
    fill: "#312E63"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M536.323 178.258C515.689 155.901 502.66 171.2 500.112 178.258C493.103 197.676 495.438 250.332 493.102 250.332C491.233 250.332 445.885 254.788 415.318 261.479L409.955 286.415C458.296 295.135 534.921 298.68 538.659 285.504C543.332 269.034 551.517 194.722 536.323 178.258Z",
    fill: "#F6BC33"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M409.955 286.415L415.318 261.479",
    stroke: "white",
    strokeWidth: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 17.1604,
    height: 156.589,
    transform: "matrix(-1 0 0 1 429.526 414.6)",
    fill: "#312E63"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M429.526 571.189H412.365L429.526 414.6V571.189Z",
    fill: "#232056"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M429.305 571.188H412.462C407.784 575.925 395.62 579.715 381.585 581.61C366.614 583.631 354.45 583.505 354.45 599.61H490.124C490.124 583.505 482.639 583.505 461.118 581.61C443.901 580.094 432.735 574.031 429.305 571.188Z",
    fill: "#232056"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M364.309 420.458L361.892 411.864H421.929C437.485 407.391 438.613 395.073 441.903 384.757C458.709 332.069 472.429 312.312 511.645 306.666C532.559 303.656 547.919 297.885 552.984 295.376C533.183 423.846 515.943 420.508 499.237 420.508C485.046 420.508 466.211 420.458 364.309 420.458Z",
    fill: "#1C43AD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 90.092,
    height: 68.6415,
    rx: 3,
    transform: "matrix(-1 0 0 1 161.131 106.5)",
    fill: "#1A9CDD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M125.072 140.232C119.5 135.356 123.621 131.185 125.943 127.993L108.193 121.979L103.307 138.49C108.531 148.067 123.413 157.209 125.072 140.232Z",
    fill: "#FECBB5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M125.943 127.993L108.193 121.979C109.222 125.83 113.592 134.323 122.842 137.48C121.029 133.777 124.071 130.567 125.943 127.993Z",
    fill: "#F1A089"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M155.544 175.056C154.151 145.107 134.689 139.146 124.823 140.017C124.033 155.021 108.757 146.781 103.308 138.491C84.5035 138.491 78.0611 162.867 77.1905 175.056H155.544Z",
    fill: "#EC6C47"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M124.822 140.017C124.033 155.021 108.756 146.781 103.307 138.491",
    stroke: "#F5BD32",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5655 175.055L94.6658 159.182M142.016 175.055L138.916 160.31",
    stroke: "#D5482A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M116.129 129.987C131.023 137.049 132.995 116.928 132.996 104.581C126.836 102.182 115.643 99.6281 113.713 102.187C104.247 98.3036 98.6103 121.679 116.129 129.987Z",
    fill: "#FECBB5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M132.996 104.581C126.836 102.182 115.643 99.6281 113.713 102.187C106.037 99.038 100.879 113.813 108.544 123.943C108.546 123.946 108.548 123.949 108.55 123.952C108.548 123.949 108.546 123.946 108.544 123.943C108.083 123.307 110.447 120.285 110.166 119.724C108.193 118.315 103.684 110.141 105.938 109.577C109.265 108.746 108.55 114.651 111.012 114.651C114.676 114.369 113.713 104.222 116.93 105.35C123.469 108.281 130.319 108.638 132.927 108.45C132.976 107.107 132.996 105.806 132.996 104.581Z",
    fill: "#F1A089"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M109.025 119.168C110.141 120.264 107.526 124.233 107.526 124.233C107.526 120.006 102.822 117.187 102.138 115.394C97.5248 103.309 107.001 103.909 106.177 100.72C104.531 94.3444 106.892 91.1551 111.833 91.1551C117.805 91.1551 121.437 94.3443 129.123 91.1555C140.651 86.3735 143.586 106.175 134.064 107.097C121.772 108.287 116.429 100.72 113.965 105.503C112.323 108.691 112.495 117.505 109.025 111.409C104.509 103.477 103.079 113.332 109.025 119.168Z",
    fill: "#05185A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M370.63 285.074H402.091C400.61 273.277 390.247 273.277 382.474 273.277C377.292 273.277 372.111 279.175 370.63 285.074Z",
    fill: "#027AC3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M382.474 273.277C376.441 273.277 372.11 279.175 370.629 285.074H372.924C373.797 280.33 379.74 271.804 396.519 275.663C392.492 273.277 387.036 273.277 382.474 273.277H382.474Z",
    fill: "#1C43AD"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M336.909 239.883C323.963 243.367 324.575 250.227 327.172 253.865H327.744C322.818 244.316 332.67 242.508 336.909 241.36C341.834 240.028 346.073 235.977 335.648 233.289C318.968 228.989 324.88 222.523 337.138 218.966C346.878 216.14 364.938 215.859 372.881 216.011C370.284 215.367 361.196 214.945 347.105 216.011C321.558 217.943 317.319 229.424 328.317 232.38C340.345 235.613 343.667 238.064 336.909 239.883Z",
    fill: "#F0E1AE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M318.164 254.244C318.164 253.139 319.059 252.244 320.164 252.244H342.915C344.019 252.244 344.915 253.139 344.915 254.244V275.074C344.915 280.597 340.438 285.074 334.915 285.074H328.164C322.641 285.074 318.164 280.597 318.164 275.074V254.244Z",
    fill: "#E85253"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M328.164 285.074H340.625C332.113 284.939 319.137 278.184 318.164 252.244V275.074C318.164 280.597 322.641 285.074 328.164 285.074Z",
    fill: "#D22F3F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M344.104 258.729C348.231 259.356 351.399 263.019 351.399 267.444C351.399 271.868 348.231 275.531 344.104 276.158",
    stroke: "#E85253",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 40.7451,
    ry: 40.7451,
    transform: "matrix(-1 0 0 1 296.221 44.25)",
    fill: "#CDEBF7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 43.7501,
    transform: "matrix(-1 0 0 1 296.221 44.2501)",
    stroke: "#1A9CDD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M297.72 43.8117C297.72 44.6401 297.049 45.3117 296.22 45.3117C295.392 45.3117 294.72 44.6401 294.72 43.8117H297.72ZM294.72 23.6582C294.72 22.8298 295.392 22.1582 296.22 22.1582C297.049 22.1582 297.72 22.8298 297.72 23.6582H294.72ZM294.72 43.8117V23.6582H297.72V43.8117H294.72Z",
    fill: "#1A9CDD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M296.876 7.00952V12.7051",
    stroke: "#1A9CDD",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M333.459 43.5925L327.764 43.5925",
    stroke: "#1A9CDD",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M296.876 74.48V80.1755",
    stroke: "#1A9CDD",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M265.99 43.5925L260.295 43.5925",
    stroke: "#1A9CDD",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M270.372 45.3115C269.544 45.3115 268.872 44.64 268.872 43.8115C268.872 42.9831 269.544 42.3115 270.372 42.3115V45.3115ZM295.783 42.3115C296.611 42.3115 297.283 42.9831 297.283 43.8115C297.283 44.64 296.611 45.3115 295.783 45.3115V42.3115ZM270.372 42.3115H295.783V45.3115H270.372V42.3115Z",
    fill: "#1A9CDD"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 4.81931,
    transform: "matrix(-1 0 0 1 296.221 44.25)",
    fill: "#1A9CDD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M696.607 332.568C707.414 321.761 728.147 290.955 724.622 254.19C717.382 265.207 696.607 304.868 696.607 332.568Z",
    fill: "#1499D0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M674.888 380.097C674.888 357.434 671.551 309.841 658.205 300.775C657.575 315.255 648.762 343.269 674.888 380.097Z",
    fill: "#1499D0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M654.428 410.001C656.316 394.368 654.931 356.491 634.282 330.05C631.135 339.178 621.376 374.432 654.428 410.001Z",
    fill: "#1499D0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M644.355 436.127C642.047 422.172 630.883 387.653 604.695 361.212C604.695 372.859 613.193 428.258 644.355 436.127Z",
    fill: "#1499D0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M654.741 410.001C668.906 399.298 704.853 378.587 735.322 381.357C721.787 393.947 704.79 412.204 654.741 410.001Z",
    fill: "#1499D0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M644.355 436.756C654.742 428.992 685.967 415.541 727.769 423.851C705.42 434.868 675.832 451.865 644.355 436.756Z",
    fill: "#1499D0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M674.888 380.412C694.088 372.963 733.938 352.901 739.73 332.252C724.306 335.4 704.791 342.01 674.888 380.412Z",
    fill: "#1499D0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M596.823 375.692C596.928 365.409 594.368 342.767 583.288 334.457C581.4 343.9 585.176 366.878 596.823 375.692Z",
    fill: "#1499D0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M597.771 376.636C595.777 370.551 587.824 358.065 571.959 356.806C577.311 368.452 583.291 373.803 597.771 376.636Z",
    fill: "#1499D0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M603.75 452.809V453.124C596.825 434.868 599.972 414.408 603.12 406.224C612.437 425.362 607.422 445.255 603.75 452.809Z",
    fill: "#1499D0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M602.489 452.81C598.502 449.242 584.233 443.367 559.051 448.403C565.347 452.81 583.918 461.624 602.489 452.81Z",
    fill: "#1499D0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M591.474 436.757C592.104 426.894 590.404 404.776 578.569 395.207C577.31 404.335 578.884 416.297 591.474 436.757Z",
    fill: "#1499D0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M589.9 436.757C580.667 433.189 559.431 426.999 548.351 430.776C554.961 434.868 566.608 444.311 589.9 436.757Z",
    fill: "#1499D0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M572.273 416.296C567.552 408.532 553.702 392.059 536.075 388.281C541.741 395.836 555.591 413.148 572.273 416.296Z",
    fill: "#1499D0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M615.081 463.197C605.323 462.043 582.597 461.623 569.754 469.178C576.05 472.01 603.435 477.047 615.081 463.197Z",
    fill: "#1499D0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M615.081 463.197C620.537 459.63 629.812 445.696 623.265 418.5C617.913 429.202 610.675 446.199 615.081 463.197Z",
    fill: "#1499D0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M641.485 480.269C632.895 444.383 614.576 429.832 610.044 403.392C605.763 387.275 599.027 377.58 596.194 374.748",
    stroke: "#0F2E9A",
    strokeWidth: 2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M636.484 482.083C636.694 462.148 644.417 414.156 673.627 381.672C700.382 353.657 691.569 334.456 700.697 320.606",
    stroke: "#0F2E9A",
    strokeWidth: 2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M635.848 478.295C635.848 472.094 606.818 465.33 589.897 435.498C579.321 419.13 565.765 410.631 560.309 408.427",
    stroke: "#0F2E9A",
    strokeWidth: 2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M614.451 463.512C614.136 463.512 582.974 470.752 569.753 469.178",
    stroke: "#0F2E9A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M601.859 452.495C600.6 452.81 575.418 453.754 559.365 448.403",
    stroke: "#0F2E9A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M589.268 436.757C578.251 435.918 554.643 433.546 548.348 430.776",
    stroke: "#0F2E9A"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M571.64 415.982C566.814 412.204 553.069 401.439 536.701 388.597",
    stroke: "#0F2E9A"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M591.158 436.442C588.744 425.53 582.911 402.069 578.882 395.522",
    stroke: "#0F2E9A"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M603.748 452.18C604.483 439.379 605.385 412.33 603.119 406.539",
    stroke: "#0F2E9A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M615.079 462.882C618.121 451.236 624.081 426.054 623.577 418.5",
    stroke: "#0F2E9A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M644.039 436.128C632.497 418.605 608.47 379.154 604.692 361.527",
    stroke: "#0F2E9A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M654.426 409.687C648.235 396.781 635.603 362.849 634.595 330.365",
    stroke: "#0F2E9A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M674.571 379.784C670.794 359.848 662.169 316.137 657.889 300.777",
    stroke: "#0F2E9A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M696.291 331.938C706.783 310.954 727.075 266.089 724.305 254.505",
    stroke: "#0F2E9A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M675.515 379.468C693.667 366.668 731.859 339.367 739.413 332.568",
    stroke: "#0F2E9A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M654.74 409.371C673.836 403.391 716.687 389.415 735.321 381.357",
    stroke: "#0F2E9A"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M644.352 436.441C665.127 435.917 710.894 432.664 727.766 423.851",
    stroke: "#0F2E9A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M596.193 374.432C592.941 363.1 585.806 339.366 583.288 335.085",
    stroke: "#0F2E9A"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M597.454 376.007C590.214 370.446 575.042 358.883 572.272 357.121",
    stroke: "#0F2E9A"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M588.012 475.159H683.032C683.798 492.103 673.758 547.556 636.692 547.556C599.626 547.556 589.815 497.494 588.012 475.159Z",
    fill: "#EC6C47"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M636.487 547.556C599.577 547.556 589.808 497.494 588.012 475.159H599.53C598.777 490.819 605.113 527.223 636.487 547.556Z",
    fill: "#D5482A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M574.789 599.807L586.094 520.64M698.179 599.807L686.874 520.64M685.187 508.824L683.526 497.193H589.442L587.781 508.824M685.187 508.824H587.781M685.187 508.824L686.874 520.64M587.781 508.824L586.094 520.64M686.874 520.64H586.094",
    stroke: "#2F2C63",
    strokeWidth: 4
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M711.383 599.771H-0.000219345",
    stroke: "#232056"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/loginImage.14d25d9616003bb5b98e3c85ba1f7a9b.svg";
export { ForwardRef as ReactComponent };